import { MMM_OPTIMIZATION_RESULTS_LIST_SEGMENT } from 'domain/mmm/optimization-results/constants';

const isListPath = (pathname) =>
  pathname.endsWith(`/${MMM_OPTIMIZATION_RESULTS_LIST_SEGMENT}`);

export default function getMmmOptimizationResultsBarOverrides(pathname) {
  if (isListPath(pathname)) {
    return {
      titleKey: 'mmm.optimization_results.list_title',
      breadcrumbs: [{ text: 'MMM分析＞最適化結果' }],
      btnDownload: false,
    };
  }

  return {
    titleKey: 'common.pages.mmm_optimization_results',
    breadcrumbs: [{ text: 'MMM分析＞' }],
    btnDownload: true,
  };
}
